import type { Adapters, SearchAdapter } from '../http/types';
import { isMacOS } from './platform';

const platform = import.meta.env.VITE_PLATFORM || 'web';
export const isNative  = platform === 'tauri' || platform === 'mobile';
export const isWeb     = platform === 'web';
export const isDesktop = platform === 'tauri';
export const isMobile  = platform === 'mobile';

/** macOS desktop only. Gates the OS-permission surfaces (mic / screen recording
 *  / accessibility), which are TCC concepts with no Windows or web equivalent. */
export const isMacDesktop = isDesktop && isMacOS;

let _adapters: Adapters;

export async function initAdapters(): Promise<void> {
  const mod = await import('../http/index');
  _adapters = mod.httpAdapters;
}

function getAdapters(): Adapters {
  if (!_adapters) throw new Error('Adapters not initialized. Call initAdapters() first.');
  return _adapters;
}

export const search: SearchAdapter = new Proxy({} as SearchAdapter, {
  get: (_, prop) => (getAdapters().search as unknown as Record<string, unknown>)[prop as string],
});

export type { Adapters, SearchAdapter } from '../http/types';
export { configureAuth, ApiError } from '../http/client';
